// extracted by mini-css-extract-plugin
export default {"greenBadge":"campaign_greenBadge__tJOU8","infoBadge":"campaign_infoBadge__yqpTL","dangerBadge":"campaign_dangerBadge__sMDBA","optionsModal":"campaign_optionsModal__SItN9"};